import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  videos: [],
  ads: [],
};

const videoSlice = createSlice({
  name: "video",
  initialState,
  reducers: {
    setVideos: (state, action) => {
      state.videos = action.payload;
    },
    setAds: (state, action) => {
      state.ads = action.payload;
    },
  },
});

export const { setVideos, setAds } = videoSlice.actions;
export default videoSlice.reducer;
